import { Pipe, PipeTransform } from '@angular/core';
import { DashboardWidget } from '../../viewmodels/dashboard/dashboard-widget';
import { WidgetDataType } from '../../views/dashboard/widgets/widget-data-type';

@Pipe({ name: 'widgetDateRangeValidator' })
export class WidgetDateRangeValidatorPipe implements PipeTransform {
  transform(dateEnd: Date, dateStart: Date, dashboardWidget: DashboardWidget): boolean {
    if (!dashboardWidget) {
      return false;
    }

    if (dashboardWidget.widget.widgetDataType !== WidgetDataType.MitigationsDueByMonth) {
      return true;
    }

    const start = typeof dateStart === 'string' ? new Date(dateStart) : dateStart;
    const end = typeof dateEnd === 'string' ? new Date(dateEnd) : dateEnd;

    if (start && end) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const result: boolean = start < end && start > yesterday;

      return result;
    }

    return false;
  }
}
